<template>
  <b-modal ref="cancellationModal"
           id="cancellationModal"
           size="lg"
           :hide-footer="true"
           centered>
    <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.Cancellation.Title}}
          </span>
          <button class="close" @click="onHide">x</button>
        </div>
    </template>
    <div>
      <div class="d-flex align-items-center mb-3">
        <strong class="mr-1">Sites:</strong>
        <v-select class="flex-grow-1" v-model="works" :getOptionLabel="param => `${param.idSite} (${param.referencia})`" multiple @option:deselected="onRemoveWork"></v-select>
      </div>
      <div class="d-flex">
        <b-form-select type="text"
                        :options="statusPci"
                        v-model="statusPciSelected" />
      </div>
      <b-row>
        <b-col cols="12"><span>{{$lang.PCI.Cancellation.LabelObservation}}</span></b-col>
        <b-col cols="12">
          <b-form-textarea v-model="observacao"
                          :max-rows="20">
          </b-form-textarea>
        </b-col>
      </b-row>
      <hr>
      <div id="div-buttons" class="d-flex justify-content-end mb-3">
        <button :disabled="getDisabled()" type="button" class="btn btn-third btn-sm" v-on:click="onSaveStatus()"><i class="fa fa-check"></i>{{$lang.PCI.Cancellation.ButtonSaveStatus}}</button>
      </div>
    </div>

    <tables ref="tableGrid" class="col-mdEW-12 tabela"
            v-if="works.length === 1"
            :columns="[$lang.PCI.Cancellation.Datatable.Date,
                      $lang.PCI.Cancellation.Datatable.Status,
                      $lang.PCI.Cancellation.Datatable.Account,
                      $lang.PCI.Cancellation.Datatable.Observation]"
            :showPaging="false"
            :showTipFooter="false"
            :showHeader="false">
      <tr v-for="obj in this.objList" :key="obj.id">
        <table-column :IsCustom="true">
          <span>
            {{obj.data}}
          </span>
        </table-column>
        <table-column :IsCustom="true">
          <span>
            {{obj.status}}
          </span>
        </table-column>
        <table-column :IsCustom="true">
          <span>
            {{obj.account}}
          </span>
        </table-column>
        <table-column :IsCustom="true">
          <span>
            {{obj.observation}}
          </span>
        </table-column>
      </tr>
    </tables>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import Tables from '@/components/forms/Tables.vue'
import TableColumn from '@/components/forms/TableColumn.vue'
import PermisionMixin from '@/store/module/permission/mixin'

export default {
  name: 'Cancellation',
  mixins: [PermisionMixin],
  components: {
    Tables,
    TableColumn
  },
  data () {
    return {
      objList: [],
      statusPciSelected: 0,
      observacao: null,
      statusPciInitial: null,
      works: [],
      statusPci: [
        {value: 0, text: this.$lang.PCI.Cancellation.StatusPci.Active},
        {value: 1, text: this.$lang.PCI.Cancellation.StatusPci.Canceled},
        {value: 2, text: this.$lang.PCI.Cancellation.StatusPci.CanceledService},
        {value: 3, text: this.$lang.PCI.Cancellation.StatusPci.ZoponeRisk},
        {value: 4, text: this.$lang.PCI.Cancellation.StatusPci.NA},
        {value: 5, text: 'On Hold'}
      ]
    }
  },
  methods: {
    getDisabled () {
      return this.statusPciSelected === this.statusPciInitial
    },
    getStatusPci (status) {
      switch (status) {
        case 1: {
          return this.$lang.PCI.Cancellation.StatusPci.Canceled
        }
        case 2: {
          return this.$lang.PCI.Cancellation.StatusPci.CanceledService
        }
        case 3: {
          return this.$lang.PCI.Cancellation.StatusPci.ZoponeRisk
        }
        case 4: {
          return this.$lang.PCI.Cancellation.StatusPci.NA
        }
        default: {
          return this.$lang.PCI.Cancellation.StatusPci.Active
        }
      }
    },
    onHide () {
      this.$refs['cancellationModal'].hide()
    },
    onClearForm () {
      this.objList = []
      this.observation = null
    },
    show (data) {
      this.works = data ? data.map(d => {
        return { obraId: d.obraId, idSite: d.idSite, referencia: d.referencia }
      }) : []
      this.$nextTick(() => {
        this.$refs['cancellationModal'].show()
        this.onClearForm()
        if (this.works.length === 1) {
          loading.push()
          WorkPCIRepository.GetStatusPci(this.works.map(w => w.obraId))
            .then((response) => {
              this.statusPciSelected = response.data.data.situacaoPci
              this.statusPciInitial = response.data.data.situacaoPci
              response.data.data.pciObraCancelamento.forEach(item => {
                this.objList.push(
                  {
                    data: item.dataAcaoFormatada,
                    account: item.nomeContaAcao,
                    status: this.getStatusPci(item.situacaoPci),
                    observation: item.observacao
                  })
              })
            })
            .catch(() => {
              toast.error(this.$lang.Common.Alerts.Error)
            })
            .finally(() => {
              loading.close()
            })
        }
      })
    },
    onRemoveWork (work) {
      if (this.works.length === 0) {
        this.works.push(work)
      }
    },
    onSaveStatus () {
      loading.push()
      WorkPCIRepository.UpdateStatusPci({
        PCIObra: this.works.map(w => w.obraId),
        SituacaoPci: this.statusPciSelected,
        Observacao: this.observacao
      })
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$emit('update')
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
          this.showCancellation = false
        })
    }
  }
}
</script>

<style scoped>
.col-md-6 {
  padding: 0px;
  padding-right: 0px;
}
td * {
  cursor: default;
}
.rejected {
  color: red;
}
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  scroll-snap-type: y proximity;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/cancellation/cancellation.vue